// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3z-Mf","author":"Table_author__1yj2z","authorImage":"Table_authorImage__3auOB","unreadRow":"Table_unreadRow__3_eRG"};